import React, { useEffect, useState } from 'react';
import { Table, Tag, Button, Modal, Form, Input, Select, message, Space } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import API from '../api';

const GROUPS = ['Household & Domestic', 'Electronics & Electrical', 'Health & Beauty', 'Healthcare & Clinical', 'Garden & Outdoor', 'Professional Services', 'Specialized & Lifestyle'];

export default function Categories() {
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState<any>(null);
  const [form] = Form.useForm();

  const load = () => {
    setLoading(true);
    API.get('/categories').then(r => setCategories(r.data)).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); form.resetFields(); setModal(true); };
  const openEdit = (r: any) => { setEditing(r); form.setFieldsValue(r); setModal(true); };

  const save = async () => {
    const values = await form.validateFields();
    if (editing) {
      await API.put(`/categories/${editing.id}`, values);
      message.success('Category updated');
    } else {
      values.isActive = true;
      await API.post('/categories', values);
      message.success('Category created');
    }
    setModal(false);
    load();
  };

  const remove = (id: number) => {
    Modal.confirm({
      title: 'Delete Category',
      content: 'This will permanently delete this category.',
      okType: 'danger',
      onOk: () => API.delete(`/categories/${id}`).then(() => { message.success('Deleted'); load(); }),
    });
  };

  const columns = [
    { title: 'Icon', dataIndex: 'icon', width: 60, render: (v: string) => <span style={{ fontSize: 20 }}>{v}</span> },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Description', dataIndex: 'description', ellipsis: true },
    { title: 'Group', dataIndex: 'groupName', render: (v: string) => <Tag>{v}</Tag> },
    { title: 'Active', dataIndex: 'isActive', render: (v: boolean) => <Tag color={v ? 'green' : 'red'}>{v ? 'Yes' : 'No'}</Tag> },
    {
      title: 'Actions', render: (_: any, r: any) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(r)}>Edit</Button>
          <Button size="small" danger icon={<DeleteOutlined />} onClick={() => remove(r.id)}>Delete</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Button type="primary" icon={<PlusOutlined />} onClick={openNew} style={{ marginBottom: 16 }}>Add Category</Button>
      <Table dataSource={categories} columns={columns} rowKey="id" loading={loading} size="middle" pagination={{ pageSize: 20 }} />

      <Modal title={editing ? 'Edit Category' : 'New Category'} open={modal} onOk={save} onCancel={() => setModal(false)} okText="Save">
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Name" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="description" label="Description" rules={[{ required: true }]}><Input.TextArea rows={2} /></Form.Item>
          <Form.Item name="icon" label="Icon (emoji)" rules={[{ required: true }]}><Input placeholder="🔧" /></Form.Item>
          <Form.Item name="groupName" label="Group" rules={[{ required: true }]}>
            <Select options={GROUPS.map(g => ({ label: g, value: g }))} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
